var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-dark pt-4 pb-5 text-trans text-center"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.siteText.footer)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }